<template>
	<el-container class="pages-common pre-tax-index">
		<leftNav />
		<el-main class="main-body" v-loading="loading" element-loading-text="导入中,请稍候"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(238, 238, 238, 0.9)">
			<div class="page-header">
				<div class="title">扣款黑名单</div>
				<el-form :inline="true" :model="formInline" class="demo-form-inline" style="display: inline-block">
					<el-form-item label="姓名">
						<el-input v-model.trim="formInline.empName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="工号">
						<el-input v-model.trim="formInline.empNo" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="身份证号">
						<el-input v-model.trim="formInline.idCard" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model.trim="formInline.remark" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="开始时间">
						<el-date-picker v-model="formInline.begin" type="month" format="yyyy-MM"
							value-format="yyyy-MM" :unlink-panels="true" clearable>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间">
						<el-date-picker v-model="formInline.end" type="month" format="yyyy-MM"
							value-format="yyyy-MM" :unlink-panels="true" clearable>
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="submitFn">查 询</el-button>
						<el-button type="warning" size="small" @click="resetFn">重 置</el-button>
					</el-form-item>
					<div class="operation-button">
						<!-- <el-button type="primary" size="small" @click="dialogVisible = true;">新 增</el-button> -->
						<el-button type="success" size="small" @click="exportExcel">导 出</el-button>
						<el-upload class="upload-demo" style="margin-left: 10px;" :action="uploadUrl"
							:headers="myHeaders" :on-progress="uploadProgress" :on-success="uploadSuccess"
							:on-error="uploadError" :file-list="fileList" :show-file-list="false" accept=".xls,.xlsx">
							<el-button type="info" size="small">导 入</el-button>
						</el-upload>

						<!-- <el-button size="small" @click="templateDownload">下载模板</el-button> -->
					</div>
				</el-form>
			</div>
			<div class="page-main">
				<el-table :data="tableList" stripe border size="small" style="width: 100%">
					
					<el-table-column prop="empName" label="姓名" width="150">
					</el-table-column>
					<el-table-column prop="empNo" label="工号" width="120">
					</el-table-column>
					<el-table-column prop="idCard" label="身份证号码" width="200">
					</el-table-column>
					<el-table-column prop="shouldChargeMonth" label="应扣月份" width="110">
					</el-table-column>
					<el-table-column prop="shouldChargeMoney" label="应扣金额" width="100">
					</el-table-column>
					<el-table-column prop="chargeMonth" label="实扣月份" width="110">
					</el-table-column>
					<el-table-column prop="chargeMoney" label="实扣金额" width="100">
					</el-table-column>
					<el-table-column prop="remark" label="备注" max-width="280">
					</el-table-column>
					<el-table-column prop="createTime" label="导入时间" width="170">
					</el-table-column>
					<el-table-column prop="createEmpName" label="导入人员" width="150">
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-main>


	</el-container>
</template>

<script>
	import leftNav from "../components/nav.vue";
	import rootUrl from "../utils/api";
	import {
		blackListChargeQuery,
		deleteBlackList,
		exportBlackList
	} from "../api/index";
	export default {
		components: {
			leftNav,
		},
		data() {
			return {
				uploadUrl: rootUrl + "/blacklist-charge/upload",
				myHeaders: {
					token: this.$store.state.loginToken,
				},
				fileList: [],
				loading: false,
				formInline: {
					empName: '',
					empNo: '',
					idCard: '',
					remark:'',
					begin: '',
					end: ''
				},
				tableList: [],

				pageSize: 10,
				currentPage: 1,
				total: 1
			}
		},
		mounted() {
			document.title = "黑名单人员扣款";
			this.queryBlackList();
		},
		methods: {
			// 获取列表数据
			queryBlackList() {
				let data = {
					"current": this.currentPage,
					"size": this.pageSize
				}
				if (this.formInline.empName) {
					data.empName = this.formInline.empName
				}
				if (this.formInline.empNo) {
					data.empNo = this.formInline.empNo
				}
				if (this.formInline.idCard) {
					data.idCard = this.formInline.idCard
				}
				if (this.formInline.begin) {
					data.begin = this.formInline.begin
				}
				if (this.formInline.end) {
					data.end = this.formInline.end
				}
				if(this.formInline.remark){
					data.remark = this.formInline.remark
				}
				blackListChargeQuery(data).then(res => {
					// console.log(res)
					if (this.currentPage == 1) {
						this.total = res.data.total;
					}
					this.tableList = res.data.rows;
				}).catch(err => {
					console.log(err)
				})
			},
			// 查询
			submitFn() {
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 重置
			resetFn() {
				this.formInline = {
					empName: '',
					empNo: '',
					idCard: '',
					remark:'',
					begin: '',
					end: ''
				};
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 改变每页显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 改变当前显示页数
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryBlackList();
			},
			
			
			
			// 导入黑名单
			uploadProgress(response, file, fileList) {
				this.loading = true;
			},
			uploadSuccess(response, file, fileList) {
			 if (response.code == 200) {
					this.$message.success(response.message)
				} else {
					this.$message.error(response.message)
				}
				this.loading = false;
				this.currentPage = 1;
				this.queryBlackList();
			},
			uploadError(err, file, fileList) {
				console.log(err);
				this.loading = false;
				// console.log(file);
				// this.loading = false;
				// this.currentPage = 1;
				// this.queryBlackList();
			},
			//导出表格
			exportExcel() {
				let data = this.formInline;
				this.loading = true;
				exportBlackList(data).then(res => {
					this.loading = false;
					const a = document.createElement("a");
					const url = window.URL.createObjectURL(res);
					const filename = '扣款黑名单列表导出.xlsx';
					a.href = url;
					a.download = filename;
					a.click();
					window.URL.revokeObjectURL(url);
					a.remove();
				}).catch(err => {
					this.loading = false;
					console.log(err);
				})
			}
		}
	}
</script>

<style>
</style>
